import styled from 'styled-components/macro';

export interface ImageStyleProps {
  background: string;
  position?: string;
  size?: string;
  height?: string;
}

export const BackgroundImageDiv = styled.div<ImageStyleProps>`
  background-image: ${({ background }) => `url(${background})`};
  background-position: ${({ position }) => (position || 'right bottom')};
  background-size: ${({ size }) => (size || '60%')};
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: ${({ height }) => (height || '100vh')};
`;
